export default () => ({
  container: {
    position: "absolute",
    bottom: 10,
  },
  white: {
    color: "rgba(255,255,255,0.54)",
  },
});
